export default __webpack_public_path__ + "static/media/multispectralBestPractices.b9cdedc1.pdf";